module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-3-74fdc77e2fbed3770eff2551c47dac3b.jpg";